export default {
    translations: {
        you: 'You',
        ok: 'OK',
        notifications: {
            userJoined: '{{name}} joined the session',
            userLeft: '{{name}} left the session',
            userWaiting: '{{name}} would like to join your session',
        },
        chat: {
            headline: 'Messages',
            encryptionFailed: 'Decryption failed',
            header: '{{names}} and you',
            noOtherUsers: 'No other person joined yet',
            newMessage: 'New message',
            sendMessage: 'Send message',
            uploadFile: 'Upload file',
            typing_one: '<i>{{name}}</i> is typing',
            typing_other: '<i>{{names}}</i> and <i>{{name}}</i> are typing',
            waitToEnter: 'You can join the session as soon as you are approved by your organizer.',
            removed: {
                title: 'Removed from the session',
                message: 'The organizer removed you from this session. This link is no longer valid.',
            },
            sessionEnded: {
                title: 'Session ended',
                message: 'The organizer ended the session for everyone.',
            },
            sessionExpired: {
                title: 'Session expired',
                message: 'Your session has expired and could not be extended. Please join the session again.',
                joinMessage: 'This session is no longer valid. Please request a new invitation link.',
            },
            sessionFailed: {
                title: 'Something went wrong',
                message: 'An error interrupted the session, and you have left it. Please join the session again.',
            },
            noSessionHere: {
                title: 'No session is open in this tab',
                message: 'Open your join link again, or join with your video interpreting ID and password.',
            },
            removedNotice: '<strong>{{name}}</strong> was removed from the session by the host.',
            joinFailed: 'Could not join. Please try again.',
            publishFailed: 'Your camera and microphone could not be transmitted. The other participants cannot see or hear you.',
            publishFailedCamera: 'Your camera could not be transmitted. The other participants cannot see you.',
            publishFailedMicrophone: 'Your microphone could not be transmitted. The other participants cannot hear you.',
            receiveFailed: 'The camera and microphone of the other participants could not be received.',
            sendFailed: 'Your message could not be sent.',
            notReadableHere: 'Not readable in this browser',
            notReadableHereNote: 'Earlier messages were encrypted for the browser you joined with before, so they cannot be decrypted here.',
            endSessionFailed: 'The session could not be ended. It is still running for the other participants.',
            prefsSaveFailed: 'Your language settings could not be saved. Please try again.',
            prefsSaveFailedJoin: 'Your language settings could not be saved. You can change them at any time under "Settings > Interpreter".',
            leaveSession: 'Leave session',
            endSession: 'End session',
            confirm: {
                closeChat: {
                    title: 'End session',
                    message: 'Do you really want to end the video interpreting session?',
                },
                leaveSession: {
                    title: 'Leave session',
                    message: 'Do you want to leave the session? You can rejoin later with the same link.',
                },
            },
        },
        signature: {
            requestSignature: 'Request signature',
        },
        videoControl: {
            enter: 'Enter',
            accept: 'Accept',
            decline: 'Decline',
            hangUp: 'Hang up',
            exit: 'Exit',
            screenShare: {
                enable: 'Share your screen',
                disable: 'End screen sharing'
            },
            camera: {
                enable: 'Turn on camera',
                disable: 'Turn off camera'
            },
            mic: {
                enable: 'Turn on microphone',
                disable: 'Turn off microphone'
            },
            pushToTalk: 'Make an announcement (please hold the button while speaking)',
            participants: 'Participants',
            messages: 'Messages',
            settings: 'Settings',
            chat: {
                show: 'Show chat',
                hide: 'Hide chat'
            }
        },
        videoGrid: {
            tileFailed: 'Video and sound unavailable',
            ownTileFailed: 'Preview unavailable',
        },
        pageFailed: {
            message: 'An error stopped the page. Reload it to join the session again.',
            reload: 'Reload',
        },
        userType: {
            translator: 'Interpreter',
            translators: 'Interpreters',
            attendee: 'Attendee',
            attendees: 'Attendees',
            moderator: 'Organizer',
            moderators: 'Organizers',
        },
        conferenceWaiting: {
            title: 'Almost there',
            message: 'You can now join the conference. Click the button below to enter the conference room.',
            yourTranslators: 'Your assigned interpreters',
            noTranslators: 'No interpreters were found for your language combination.',
            audibleUsers: 'Users you will hear',
            noAudibleUsers: 'No participants found yet. The list updates automatically.',
            continue: 'Continue to conference',
        },
        sidebar: {
            participants: {
                admit: 'Admit',
                admitFailed: 'The participant could not be admitted. Please try again.',
                remove: 'Remove',
                removeFailed: 'The participant could not be removed. Please try again.',
                confirmRemove: {
                    title: 'Remove from session',
                    message: 'Are you sure you want to remove this person? After removal they will be taken off the participant list and can no longer join this session.',
                },
            },
            settings: {
                title: 'Settings',
                video: 'Video',
                audio: 'Audio',
                interpreter: 'Interpreter',
                save: 'Save',
                saving: 'Saving...',
                reset: 'Reset',
            },
        },
        conferenceInfo: {
            title: 'Conference information',
            languages: 'Languages',
            neededLanguages: 'Select the language(s) for which you need an interpreter',
            spokenLanguage: 'Select your spoken language',
            simultanConfig: 'Select your simultaneous interpreting setting',
            simultanReduce: 'I would like to reduce the volume of the speaker.',
            simultanMute: 'I would like to mute the volume of the speaker.',
            selectPlaceholder: 'Select',
            continue: 'Continue to conference',
            preferencesSet: 'Your language preferences have already been saved.',
            yourParticipants: 'Participants assigned to you',
            noParticipantsYet: 'No participants assigned yet. The list updates automatically.',
            summary: {
                spoken: 'Language you speak',
                needInterpretation: 'Languages you need interpretation for',
                understood: 'Languages you understand',
            },
        },
        lobby: {
            button: {
                video: {
                    enable: 'Turn on camera',
                    disable: 'Turn off camera',
                },
                microphone: {
                    enable: 'Turn on microphone',
                    disable: 'Turn off microphone',
                },
                settings: 'Device settings',
            },
            loading: 'Loading',
            camera: 'Camera',
            noCamera: 'No camera',
            cameraOff: 'Camera turned off',
            cameraStarting: 'Camera starting…',
            simultanConfigInfo: 'In simultaneous interpreting, participants and interpreters speak almost simultaneously. To help you hear the interpretation clearly, the original speaker is automatically turned down.\n\nYou have two options:\n\n1) Reduced volume: You hear the interpretation normally and the speaker quietly in the background.\n\n2) Muted: You only hear the interpretation.\n\nYou can change this setting at any time under "Settings > Interpreter".',
            spokenLanguageInfo: 'Is your language not listed? Please contact the organizer of this video interpreting session. You can still join and change the language at any time under "Settings > Interpreter".',
            cameraDenied: 'Access to your camera was blocked by your browser. Please allow camera access in your browser settings.',
            cameraDeniedSystem: 'Access to your camera was blocked by your operating system. Please allow camera access in your system settings.',
            cameraUnavailable: 'Your camera could not be started. It may be in use by another application.',
            cameraNotFound: 'No camera was found. Please connect a camera, or check whether it has been disabled in your system settings.',
            cameraLost: 'Your camera keeps disconnecting. Please check its connection or choose another camera, then try again.',
            microphoneDenied: 'Access to your microphone was blocked by your browser. Please allow microphone access in your browser settings.',
            microphoneDeniedSystem: 'Access to your microphone was blocked by your operating system. Please allow microphone access in your system settings.',
            microphoneUnavailable: 'Your microphone could not be started. It may be in use by another application.',
            microphoneNotFound: 'No microphone was found. Please connect a microphone, or check whether it has been disabled in your system settings.',
            microphoneLost: 'Your microphone keeps disconnecting. Please check its connection or choose another microphone, then try again.',
            microphoneMutedSystem: 'Your microphone was muted by your operating system and other participants cannot hear you. Please unmute it with the microphone key on your device or in your system settings.',
            retry: 'Try again',
            deviceListFailed: 'Your devices could not be read. Camera, microphone and speaker selection may be incomplete.',
            none: 'None',
            systemDefault: 'Default',
            cameraFallback: 'Your previously selected camera is not available. "{{name}}" will be used instead.',
            microphoneFallback: 'Your previously selected microphone is not available. "{{name}}" will be used instead.',
            speakerFallback: 'Your previously selected speaker is not available. "{{name}}" will be used instead.',
            speakerUnavailable: 'The selected speaker could not be used. Playback continues on your system default device.',
            speakerBlocked: 'Your browser does not allow choosing an output device. Playback runs on your system default device — please change it in your system settings.',
            speakerTest: 'Test',
            speakerTesting: 'Tone playing…',
            speakerTestPlayed: 'A test tone was played through "{{name}}". If you heard nothing, check your device volume and whether it is muted. Or choose a different speaker below.',
            speakerTestFailed: 'The test tone could not be played.',
            speakerNotFound: 'No playback device was found. Please connect a speaker or headphones, or check whether the device has been disabled in your system settings.',
            microphone: 'Microphone',
            microphoneLevel: 'Microphone input level',
            microphoneTest: 'Test',
            microphoneTestRecording: 'Recording…',
            microphoneTestPlaying: 'Playing back…',
            microphoneTestStop: 'Stop',
            microphoneTestMuteHint: 'The other participants cannot hear you while the test is running',
            microphoneTestStarted: 'Recording. The other participants cannot hear you while the test is running.',
            microphoneTestPlayed: 'Your recording was played through "{{name}}". It stays in your browser and is neither stored nor transmitted.',
            microphoneTestPlayedLive: 'Your recording was played through "{{name}}". It stays in your browser and is neither stored nor transmitted. The other participants cannot hear you while the test is running.',
            microphoneTestFailed: 'The recording could not be played back.',
            microphoneTestMuted: 'Your microphone is off. Turn it on to test a recording.',
            microphoneTestMutedSystem: 'Your microphone is muted in your system settings. Turn it on to test a recording.',
            speaker: 'Speaker',
            speakerLevel: 'Speaker output level',
            background: 'Background',
            backgroundOptions: {
                none: 'No change',
                blur: 'Soft focus',
                hide: 'Hide',
            },
            yourName: 'Your Information',
            nameLabel: 'Enter your name',
            enterNow: 'Join now',
            leave: 'Leave',
            noPermission: 'No Permission',
            agb: {
                prefix: 'By joining you agree to our',
                terms: 'Terms of Service',
                conjunction: 'and',
                privacy: 'Privacy Policy',
                suffix: '.',
            },
        }
    }
}
